import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import Sidenav from '../../components/Sidenav/Sidenav';

const DashboardLayout = () => {
  const token = localStorage.getItem('authToken');

  return (
    <div className="d-flex">
      {/* Sidebar */}
      <div className="position-sticky top-0" style={{ width: '250px', height: '100vh' }}>
        <Sidenav />
      </div>

      {/* Main Content */}
      <div className="flex-grow-1 p-4 bg-light" style={{ height: '100vh', overflowY: 'auto' }}>
        {token ? <Outlet /> : <Navigate to="/" />}
      </div>
    </div>
  );
};

export default DashboardLayout;

